import { Skeleton } from '@shared/components/ui/shadcn';

/**
 * Componente ClientSelectorSkeleton - Muestra skeleton para el selector de cliente
 * 
 * Este componente replica la estructura de ClientSelector pero con skeletons
 * para mostrar un estado de carga visual mientras se cargan los datos.
 */
export const ClientSelectorSkeleton = () => {
  return (
    <div className="border border-card-border rounded-lg p-4 mb-6 shadow-sm">
      {/* Encabezado del selector - Selector header */}
      <div>
        <Skeleton className="h-6 w-40 rounded-full mb-2 bg-hover-press" />
        <Skeleton className="h-4 w-80 rounded-full bg-hover-press" />
      </div>

      {/* Selector de cliente - Client picker */}
      <div className="mt-4">
        <Skeleton className="h-10 w-full bg-hover-press" />
      </div>

      {/* Mensaje de estado - Status message */}
      <div className="mt-4">
        <div className="flex items-center gap-3 rounded-lg border border-card-border bg-card-bg px-4 py-4">
          <Skeleton className="w-4 h-4 rounded-full bg-hover-press" />
          <Skeleton className="h-4 w-64 rounded-full bg-hover-press" />
        </div>
      </div>
    </div>
  );
};

